var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgJoystick = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 67.016,
    height: 47.018,
    viewBox: "0 0 67.016 47.018",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.008 -8.039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.188,17.01C50.6,2.268,37.67,12.524,37.67,12.524a6.513,6.513,0,0,1-3.436,1.21l-3.464,0a6.469,6.469,0,0,1-3.435-1.206S14.4,2.272,5.813,17.014.689,47.8.689,47.8c.606,3.93,2.6,6.552,6.373,6.223S18.979,43.441,18.979,43.441a4.57,4.57,0,0,1,3.134-1.535l20.768,0a4.562,4.562,0,0,1,3.133,1.535s8.16,10.255,11.925,10.583,5.767-2.3,6.37-6.223C64.308,47.8,67.773,31.75,59.188,17.01ZM24.7,29.01H20.242V33.5a4.035,4.035,0,0,1-2.4.734,2.846,2.846,0,0,1-2.116-.821v-4.4H11.517a3.624,3.624,0,0,1-.665-2.043,4.851,4.851,0,0,1,.581-2.678h4.454V19.635a4.672,4.672,0,0,1,2.234-.474,5.691,5.691,0,0,1,2.285.561l-.018,4.566h4.206a4.483,4.483,0,0,1,.8,2.176A5.675,5.675,0,0,1,24.7,29.01Zm20.426,5.113a3.688,3.688,0,1,1,3.526-3.684A3.6,3.6,0,0,1,45.122,34.123Zm0-10.136A3.687,3.687,0,1,1,48.648,20.3,3.6,3.6,0,0,1,45.122,23.987ZM53.9,29.428a3.688,3.688,0,1,1,3.526-3.684A3.6,3.6,0,0,1,53.9,29.428Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#3d5567",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJoystick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/joystick.63ab0adf.svg";
export { ForwardRef as ReactComponent };